import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Heart } from "lucide-react";

import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useSaveToggle } from "@/hooks/use-save-toggle";
import { MatchCard } from "@/components/match-card";
import { BackHeader } from "@/components/back-header";
import { EmptyState, ErrorState, Loading } from "@/components/ui";

export default function Saved() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const toggleSave = useSaveToggle();
  const { data, isLoading, isError, error, refetch } = useQuery({ queryKey: ["saved"], queryFn: () => api("/saved") });
  return (
    <div data-testid="saved-screen">
      <BackHeader title="Saved Profiles" />
      {isLoading ? <Loading /> : isError ? <ErrorState testId="saved-error" message={error.message} onRetry={() => refetch()} /> : !data?.saved.length ? (
        <EmptyState testId="saved-empty" icon={Heart} title="No saved profiles yet." text="Tap the heart on any match to save it here." />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
          {data.saved.map((m, i) => (
            <MatchCard key={m.id} index={i} profile={m} requestLabel={user?.request_label}
              onView={() => navigate(`/member/${m.id}`)} onRequest={() => navigate(`/member/${m.id}`)} onToggleSave={() => toggleSave(m.id, true)} />
          ))}
        </div>
      )}
    </div>
  );
}
